import {
  autocompleteClasses,
  type AutocompleteRenderInputParams,
} from "@mui/material/Autocomplete";
import { inputBaseClasses } from "@mui/material/InputBase";
import MuiTextField, {
  type TextFieldProps as MuiTextFieldProps,
} from "@mui/material/TextField";
import { type ReactNode } from "react";
import InfoAdornment from "@/components/common/formElements/library/InfoAdornment";

export interface AutocompleteTextInputProps
  extends AutocompleteRenderInputParams,
    Partial<
      Pick<
        MuiTextFieldProps,
        | "inputRef"
        | "label"
        | "error"
        | "placeholder"
        | "required"
        | "variant"
        | "helperText"
        | "onBlur"
        | "slotProps"
      >
    > {
  tooltip?: ReactNode;
}

export default function AutocompleteTextInput(
  props: AutocompleteTextInputProps,
) {
  const { tooltip, slotProps, ...params } = props;

  return (
    <MuiTextField
      {...params}
      sx={{
        ...(tooltip && {
          [`& .${inputBaseClasses.root}`]: {
            paddingRight: "84px!important",
          },
        }),
      }}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          ...params.InputProps,
          ...(tooltip && {
            sx: {
              [`& .${autocompleteClasses.endAdornment}`]: {
                right: "36px!important",
              },
            },
          }),
          endAdornment: (
            <>
              {params.InputProps.endAdornment}
              {tooltip && (
                <InfoAdornment
                  tooltip={tooltip}
                  inputAdornmentProps={{
                    sx: {
                      position: "absolute",
                      right: "14px",
                      top: "50%",
                      transform: "translate(0, -50%)",
                    },
                  }}
                />
              )}
            </>
          ),
        },
      }}
    />
  );
}
